import { render, staticRenderFns } from "./TokenForm.vue?vue&type=template&id=1f5a403e&"
import script from "./TokenForm.vue?vue&type=script&lang=ts&"
export * from "./TokenForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports